import React from "react";
import { Skeleton, IconButton, Avatar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

function SkeletonWithComponents() {
  return (
    <>
      <Skeleton
        variant="rectangular"
        width='100%'
        height={30}
      />
      <div
        style={{
          minWidth: "50px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginRight: "20px",
            }}
          >
            <Skeleton variant="circular" width={100} height={100} />

            <Skeleton
              variant="rectangular"
              width={100}
              height={30}
              style={{ marginTop: "10px" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Skeleton variant="circular" width={100} height={100} />

            <Skeleton
              variant="rectangular"
              width={100}
              height={30}
              style={{ marginTop: "10px" }}
            />
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Skeleton height={20} width="70%" />
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Skeleton height={50} width="90%" />
        </div>
      </div>
    </>
  );
}

export default SkeletonWithComponents;
